import { render } from "./TwZipcode.vue?vue&type=template&id=28df1271"
import script from "./TwZipcode.vue?vue&type=script&lang=js"
export * from "./TwZipcode.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__